import { IAmendmentCover } from '..';

export const initialCoverValues: {
  initialError: Record<keyof IAmendmentCover, string>;
  initialTouched: Record<keyof IAmendmentCover, boolean>;
} = {
  initialError: {
    coverPremiumType: '',
    coverPremiumPercentage: '',
    coverPremiumValue: '',
    currency: '',
    coverSumInsured: '',
    sumInsuredIsAdditive: '',
    excessOnClaimType: '',
    excessOnClaimAmount: '',
    excessOnClaimPercentage: '',
    excessOnClaimDays: '',
    coverEffectiveFrom: '',
    coverEffectiveTo: '',
    amendmentCoverSumInsured: '',
    amendmentCoverPremiumPercentage: '',
    amendmentCoverPremiumValue: '',
    amendmentExcessOnClaimAmount: '',
    amendmentExcessOnClaimPercentage: '',
    amendmentExcessOnClaimDays: '',

    isMain: '',
    isMandatory: '',
    isEditable: '',
    clauseID: '',
    coverValuesBackUp: '',
    isNew: '',
    isRemoved: '',
    isRemovedBackup: '',
    name: '',
    policyCover: '',
    proRataRatio: '',
  },
  initialTouched: {
    coverPremiumType: false,
    coverPremiumPercentage: false,
    coverPremiumValue: false,
    currency: false,
    coverSumInsured: false,
    sumInsuredIsAdditive: false,
    excessOnClaimType: false,
    excessOnClaimAmount: false,
    excessOnClaimPercentage: false,
    excessOnClaimDays: false,
    coverEffectiveFrom: false,
    coverEffectiveTo: false,
    amendmentCoverSumInsured: false,
    amendmentCoverPremiumPercentage: false,
    amendmentCoverPremiumValue: false,
    amendmentExcessOnClaimAmount: false,
    amendmentExcessOnClaimPercentage: false,
    amendmentExcessOnClaimDays: false,

    isMain: false,
    isMandatory: false,
    isEditable: false,
    clauseID: false,
    coverValuesBackUp: false,
    isNew: false,
    isRemoved: false,
    isRemovedBackup: false,
    name: false,
    policyCover: false,
    proRataRatio: false,
  },
};
